import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axiosInstance';
import { BASE_URL } from '../config';

export const fetchLogs = createAsyncThunk('logs/fetchLogs', async (_, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.get(`${BASE_URL}/admin/logs`);
		return res.data;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Failed to fetch logs.');
	}
});

export const fetchLogContent = createAsyncThunk('logs/fetchLogContent', async (filename, { rejectWithValue }) => {
	try {
		const res = await axiosInstance.get(`${BASE_URL}/admin/logs/${encodeURIComponent(filename)}`);
		return { filename, content: res.data };
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Failed to fetch log content.');
	}
});

export const deleteLog = createAsyncThunk('logs/deleteLog', async (filename, { rejectWithValue }) => {
	try {
		await axiosInstance.delete(`${BASE_URL}/admin/logs/${encodeURIComponent(filename)}`);
		return filename;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Failed to delete log.');
	}
});

const logsSlice = createSlice({
	name: 'logs',
	initialState: {
		logs: [],
		selectedLog: null,
		logContent: '',
		loading: false,
		error: '',
		deleting: '',
	},
	reducers: {
		clearLogContent(state) {
		state.selectedLog = null;
		state.logContent = '';
		},
		clearError(state) {
		state.error = '';
		},
	},
	extraReducers: (builder) => {
		builder
		// Fetch logs
		.addCase(fetchLogs.pending, (state) => {
			state.loading = true;
			state.error = '';
		})
		.addCase(fetchLogs.fulfilled, (state, action) => {
			state.loading = false;
			state.logs = action.payload;
		})
		.addCase(fetchLogs.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		})
		// Fetch log content
		.addCase(fetchLogContent.pending, (state, action) => {
			state.loading = true;
			state.error = '';
			state.selectedLog = action.meta.arg;
			state.logContent = '';
		})
		.addCase(fetchLogContent.fulfilled, (state, action) => {
			state.loading = false;
			state.selectedLog = action.payload.filename;
			state.logContent = action.payload.content;
		})
		.addCase(fetchLogContent.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		})
		// Delete log
		.addCase(deleteLog.pending, (state, action) => {
			state.deleting = action.meta.arg;
			state.error = '';
		})
		.addCase(deleteLog.fulfilled, (state, action) => {
			state.deleting = '';
			state.logs = state.logs.filter((log) => log !== action.payload);
			if (state.selectedLog === action.payload) {
			state.selectedLog = null;
			state.logContent = '';
			}
		})
		.addCase(deleteLog.rejected, (state, action) => {
			state.deleting = '';
			state.error = action.payload;
		});
	},
});

export const { clearLogContent, clearError } = logsSlice.actions;
export default logsSlice.reducer;
